<script setup lang="ts">
import { computed } from "vue";
import { SegmentationStatus } from "@/models/SegmentationStatus";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

interface Props {
    segmentationStatus: SegmentationStatus;
}

const isUnknown = computed(() => props.segmentationStatus === SegmentationStatus.UNKNOWN);
const inProgress = computed(() => props.segmentationStatus === SegmentationStatus.IN_PROCESS);

const props = defineProps<Props>();

const segmentationText = computed(() => {
    switch (props.segmentationStatus) {
        case SegmentationStatus.COMPLETED:
            return t("web-rg.performed");
        case SegmentationStatus.FAILED:
            return t("shared.failed");
        case SegmentationStatus.IN_PROCESS:
            return t("shared.inProgress");
        case SegmentationStatus.NOT_STARTED:
            return t("web-rg.notPerformed");
        case SegmentationStatus.UNKNOWN:
        default:
            return t("web-rg.unknown");
    }
});
</script>

<template>
    <template v-if="isUnknown">
        <Skeleton></Skeleton>
    </template>
    <template v-else>
        <div class="flex flex-row content-center" :class="[{ 'pt-2': inProgress }]">
            <div v-if="inProgress">
                <ProgressSpinner animationDuration="0.6s" style="width: 40px; height: 25px" strokeWidth="6" />
            </div>
            <div>{{ segmentationText }}</div>
        </div>
    </template>
</template>

<style scoped></style>
